import { Navigate, useLocation } from 'react-router-dom';
import store from '../redux/store';

const PrivateRoutesCounsultant = ({ children }) => {
	const ConsultantToken = store.getState().consultant;
	const location = useLocation();
	const lang = location.pathname.startsWith('/fr') ? 'fr' : 'en';
	return ConsultantToken.Token !== '' && ConsultantToken.status ? children : <Navigate to={`/${lang}/public/consultant/sign-in`} />;
};

export default PrivateRoutesCounsultant;
